import { createModel } from '@rematch/core';
import $ from 'jquery';
import debouncer from '../modules/debouncer';
import type { RootModel } from './models';

const debounce = debouncer();

/**
 * A model for managing the visibility of the global lion loader.
 *
 * Uses a debouncer to ensure the loader isn't rapidly shown/hidden in succession.
 * To show the loader, call dispatch.loader.setIsLoading(true).
 * To hide the loader, call dispatch.loader.setIsLoading(false).
 */
const Loader = createModel<RootModel>()({
  state: {
    isLoading: false,
  },
  reducers: {
    setState: (state, payload: { isLoading: boolean }) => ({
      ...payload,
    }),
  },
  effects: dispatch => ({
    setIsLoading(isLoading: boolean) {
      dispatch.loader.setState({ isLoading });
      debounce(dispatch.loader.updateLoaderDisplay);
    },
    updateLoaderDisplay(_: never, rootState) {
      const { loader } = rootState;
      const loaderNode = $('#loader');
      if (loaderNode.length) {
        if (loader.isLoading) {
          loaderNode.show();
        } else {
          loaderNode.hide();
        }
      } else {
        // DOM not loaded yet, try again shortly
        debounce(dispatch.loader.updateLoaderDisplay);
      }
    },
  }),
});

export default Loader;
